module.exports = __webpack_public_path__ + "static/media/ic_wcag_animation_play.55eecbe0.svg";